// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading_Loading___lX79","LoadingSync":"Loading_LoadingSync__U_XNN","Open":"Loading_Open__2w0zB"};